import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	isVisible: boolean
}

export const Container = styled.div<Props>`
	display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
	column-gap: 4px;
	transition: height 0.2s ease;
	width: 100%;
	text-align: left;
	margin-top: 4px;
	color: ${({ theme }) => theme.color.danger};
	font-size: ${helpers.font.size.small};

	> svg {
		margin-top: 2px;
		flex-shrink: 0;
	}
`
